// extracted by mini-css-extract-plugin
module.exports = {"posts":"posts-module--posts--Xt1u4","header":"posts-module--header--1n7Hy","filters":"posts-module--filters--1b94I"};